import { render, staticRenderFns } from "./ComposantsComponent.vue?vue&type=template&id=63bf5522&"
import script from "./ComposantsComponent.vue?vue&type=script&lang=js&"
export * from "./ComposantsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ComposantsComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports